import { el } from "./dom.js";

function openDialog(build) {
  const dialog = document.getElementById("dialog");
  const opener = document.activeElement;
  return new Promise((resolve) => {
    let settled = false;
    const finish = (value) => {
      if (settled) return;
      settled = true;
      dialog.close();
      if (opener && document.contains(opener)) opener.focus();
      resolve(value);
    };
    dialog.replaceChildren();
    dialog.oncancel = (event) => {
      event.preventDefault();
      finish(null);
    };
    build(dialog, finish);
    const heading = dialog.querySelector("h2");
    if (heading) {
      heading.id = "dialog-title";
      dialog.setAttribute("aria-labelledby", "dialog-title");
    }
    dialog.showModal();
  });
}

const buttonRow = (...buttons) => el("div", { class: "dialog-buttons" }, buttons);
const button = (label, onclick, className = "") => el("button", { type: "button", class: className, onclick }, label);

export async function chooseUnsaved({ message, saveLabel = "Save" }) {
  const choice = await openDialog((dialog, finish) =>
    dialog.append(
      el("h2", {}, "Unsaved changes"),
      el("p", {}, message),
      buttonRow(
        button(saveLabel, () => finish("save"), "primary-btn"),
        button("Discard changes", () => finish("discard"), "danger-btn"),
        button("Cancel", () => finish("cancel")),
      ),
    ));
  return choice ?? "cancel";
}

export async function confirmAction(title, message, confirmLabel) {
  const result = await openDialog((dialog, finish) =>
    dialog.append(
      el("h2", {}, title),
      el("p", {}, message),
      buttonRow(button(confirmLabel, () => finish(true), "danger-btn"), button("Cancel", () => finish(false))),
    ));
  return result === true;
}

export async function showMessages(title, lines) {
  await openDialog((dialog, finish) =>
    dialog.append(
      el("h2", {}, title),
      el("ul", {}, lines.map((line) => el("li", {}, line))),
      buttonRow(button("OK", () => finish(true), "primary-btn")),
    ));
}

export function newProfileDialog({ builtIns, takenNames }) {
  return openDialog((dialog, finish) => {
    const name = el("input", { type: "text", id: "new-profile-name", autocomplete: "off", "aria-describedby": "new-profile-error" });
    const error = el("p", { class: "field-error", id: "new-profile-error", hidden: true });
    const options = [
      ...builtIns.map((p) => [p.id, p.name, p.description]),
      ["empty", "Empty", "No rules at all. Every style falls back to mammoth's plain defaults."],
    ];
    const startFrom = el("fieldset", { class: "radios" },
      el("legend", {}, "Start from"),
      options.map(([value, label, hint], i) => el("label", { class: "radio" },
        el("input", { type: "radio", name: "start-from", value, checked: i === 0 }),
        el("span", {}, el("strong", {}, label), el("span", { class: "hint block" }, hint)))));
    const form = el("form", {
      onsubmit: (event) => {
        event.preventDefault();
        const value = name.value.trim();
        const problem = !value ? "Enter a name for the profile."
          : takenNames.has(value.toLowerCase()) ? "You already have a profile with that name." : "";
        if (problem) {
          error.textContent = problem;
          error.hidden = false;
          name.setAttribute("aria-invalid", "true");
          name.focus();
          return;
        }
        finish({ name: value, startFrom: form.querySelector("input[name=start-from]:checked").value });
      },
    },
    el("h2", {}, "New profile"),
    el("div", { class: "field" }, el("label", { for: "new-profile-name" }, "Name"), name, error),
    startFrom,
    buttonRow(el("button", { type: "submit", class: "primary-btn" }, "Create profile"), button("Cancel", () => finish(null))));
    dialog.append(form);
    queueMicrotask(() => name.focus());
  });
}
